import { t } from "./i18n";

export const OM_OSS = [
  { label: t("Dette er EQVA"), href: "/om-oss", desc: t("Konsernet, modellen og historien vår") },
  { label: t("Strategi og eierskapsmodell"), href: "/om-oss/strategi", desc: t("Hvordan vi kjøper, eier og utvikler industriselskaper") },
  { label: t("Ledelse og styre"), href: "/om-oss/ledelse", desc: t("Konsernledelsen og styret") },
  { label: t("Bærekraft"), href: "/om-oss/baerekraft", desc: t("Klima, ansvar og etikk i praksis") },
  { label: t("Karriere"), href: "/om-oss/karriere", desc: t("Muligheter i EQVA-selskapene") },
  { label: t("Kontakt"), href: "/om-oss/kontakt", desc: t("Finn riktig selskap eller kontaktperson") },
];

/* Main navigation: five entries, companies first – EQVA is the companies. */
export const NAV = [
  { label: t("Selskaper"), href: "/selskaper", id: "selskaper" },
  { label: t("Tjenester"), href: "/tjenester", id: "tjenester" },
  { label: t("Markeder"), href: "/markeder", id: "markeder" },
  { label: t("Aktuelt"), href: "/aktuelt", id: "aktuelt" },
  { label: t("Om EQVA"), href: "/om-oss", id: "om-oss", children: OM_OSS },
];

/* Utilities at the far right of the header (desktop) and the tail of the mobile menu. */
export const UTILITY_NAV = [
  { label: t("Bli en del av EQVA"), href: "/bli-en-del-av-eqva", id: "bli-en-del" },
  { label: t("Investor"), href: "/investor", id: "investor" },
];

export const INVESTOR_LINKS = [
  { label: t("Investorportalen ir.eqva.no"), href: "https://ir.eqva.no", external: true },
  { label: t("Aksjen"), href: "/investor" },
  { label: t("Rapporter og presentasjoner"), href: "/investor#rapporter" },
  { label: t("Finansiell kalender"), href: "/investor#kalender" },
  { label: t("Aksjonærer"), href: "/investor#aksjonaerer" },
  { label: t("Børsmeldinger"), href: "https://newsweb.oslobors.no/search?issuer=EQVA", external: true },
];

export const NEWSWEB_URL = "https://newsweb.oslobors.no/search?issuer=EQVA";
/* The official investor relations portal (external). Investors are routed here first. */
export const IR_PORTAL_URL = "https://ir.eqva.no";
